import productModal from "@/js/alpine/productModal";
import Alpine from 'alpinejs';

export default function () {
    productModal();

    Alpine.start();
}
